// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1GZae","image":"App_image__3NkaW"};